module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Emma-Skating-1280.03685dfc.jpg";